"use client";

import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useTranslations } from "next-intl";
import { useState } from "react";
import type { FieldValues, UseFormReturn } from "react-hook-form";
import { Button } from "@/components/ui/button";
import { CaloriesCalculatorDialog } from "@/features/calories-calculator/components/calories-calculator-dialog";
import type { CaloriesRange } from "@/features/calories-calculator/types/calories-calculator.type";

type FilterCaloriesCalculatorProps = {
  caloriesRanges: CaloriesRange[];
  paramName: string;
  form?: UseFormReturn<FieldValues>;
};

export const FilterCaloriesCalculator = ({
  caloriesRanges,
  form,
  paramName,
}: FilterCaloriesCalculatorProps) => {
  const t = useTranslations("calories-calculator");
  const [isOpen, setIsOpen] = useState(false);
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const { replace } = useRouter();

  const applyCalories = (label: string) => {
    if (form) {
      form.setValue(paramName, label, { shouldDirty: true });
      return;
    }

    const params = new URLSearchParams(searchParams);
    params.set(paramName, label);
    params.delete("page");

    replace(`${pathname}?${params.toString()}`);
  };

  return (
    <>
      <Button
        className="mt-4 w-full bg-transparent font-medium"
        onClick={() => setIsOpen(true)}
        type="button"
        variant="outline"
      >
        {t("trigger")}
      </Button>

      <CaloriesCalculatorDialog
        caloriesRanges={caloriesRanges}
        onApplyCalories={applyCalories}
        onOpenChange={setIsOpen}
        open={isOpen}
      />
    </>
  );
};
